import { render, staticRenderFns } from "./FormQuestionDetails.vue?vue&type=template&id=16f5e036"
import script from "./FormQuestionDetails.vue?vue&type=script&lang=js"
export * from "./FormQuestionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports